var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2561 23.7604C0.36625 23.8706 0.492923 23.9422 0.636119 23.9752C0.779314 24.0083 0.92251 24.0083 1.06571 23.9752C1.2089 23.9422 1.34108 23.8706 1.46225 23.7604L12.0036 13.2021L22.5616 23.7604C22.7268 23.9146 22.9251 23.9917 23.1564 23.9917C23.3877 24.0028 23.586 23.9256 23.7512 23.7604C23.9164 23.5842 23.999 23.3804 23.999 23.1491C23.999 22.9177 23.9164 22.7194 23.7512 22.5542L13.2098 11.9959L23.7512 1.45404C23.9164 1.28881 23.999 1.09053 23.999 0.859208C24.01 0.616867 23.9274 0.413081 23.7512 0.247849C23.586 0.0826162 23.3877 0 23.1564 0C22.9251 0 22.7268 0.0826162 22.5616 0.247849L12.0036 10.8062L1.46225 0.247849C1.34108 0.137694 1.2089 0.0660929 1.06571 0.0330465C0.92251 0 0.779314 0 0.636119 0.0330465C0.492923 0.0660929 0.36625 0.137694 0.2561 0.247849C0.145949 0.369019 0.068844 0.501205 0.0247838 0.644406C-0.00826128 0.787608 -0.00826128 0.930809 0.0247838 1.07401C0.068844 1.21721 0.145949 1.34389 0.2561 1.45404L10.7975 11.9959L0.2561 22.5542C0.145949 22.6644 0.068844 22.791 0.0247838 22.9343C-0.00826128 23.0775 -0.00826128 23.2207 0.0247838 23.3639C0.068844 23.5181 0.145949 23.6503 0.2561 23.7604Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.9e9a60aab7cd558e566621e0c53a88cc.svg";
export { ForwardRef as ReactComponent };